import React, {Fragment, useContext} from 'react'
import { Dialog, Transition } from '@headlessui/react'
import { XMarkIcon } from '@heroicons/react/24/outline'
import { APIGetPlanRefUrl } from "#src/api/plans/Plans";
import { GoDownload } from "react-icons/go";
import {ViewerContext} from "../../context/ViewerContext";
import { MdArrowForwardIos, MdLinearScale } from "react-icons/md";
import { PiPolygon } from "react-icons/pi";
import { TbPointFilled } from "react-icons/tb";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import { handleZoomToLayer,handleLayerBlink} from "#src/xPlanViewer/utils/mapHandlers";
import { RiFocus3Line } from "react-icons/ri";



export default function Comment() {
    const { detailsData, showDetails,map, setShowDetails, layerBlink, setLayerBlink, id, refs } = useContext(ViewerContext);

        const generateDownloadUrl = async (filename) => {
            try {
                const url = await APIGetPlanRefUrl(id, filename);
                if (!url) {
                    console.error('No URL returned from API');
                    return;
                }
                const link = document.createElement('a');
                link.href = url;
                link.download = filename;
                link.click();
            } catch (error) {
                console.error('Error generating download URL:', error);
            }
        };

    const parseDetails = (data) => {
        if(typeof data !== "undefined") {
            return (
                <div className={"pl-1.5"}>
                    <ul className={"max-w-3XL gap-y-6 rounded-md"}>
                        {
                            Object.keys(data).map((key, index)=> {
                                if(data?.[key]?.values !== "") {
                                    if(data?.[key]?.name === "Referenz Scan" || data?.[key]?.name === "Referenzen") {
                                        return (
                                            <li className={"mb-4"} key={index}>
                                                <span className={"text-xs font-bold mb-2 text-gray-900 block"} id={data?.[key]?.name} title={data?.[key]?.name}>{data?.[key]?.name}:</span>
                                                <div  className={"border-gray-300 border-l-2 "}>
                                                    {data?.[key]?.values?.['xplan:referenzName'] && data?.[key]?.values?.['xplan:referenzName'] !== "" && (
                                                        <div  className={"text-xs pb-3 pl-2"}>
                                                            <b className={"text-gray-600/60 "}>Name: </b><br/> {data?.[key]?.values?.['xplan:referenzName']?.toString()}
                                                        </div>
                                                    )}
                                                    {data?.[key]?.values?.['xplan:datum'] && data?.[key]?.values?.['xplan:datum'] !== "" && (
                                                        <div  className={"text-xs pb-3 pl-2"}>
                                                            <b className={"text-gray-600/60 "}>Datum: </b><br/> {data?.[key]?.values?.['xplan:datum']?.toString()}
                                                        </div>
                                                    )}
                                                    {data?.[key]?.values?.['xplan:art'] && data?.[key]?.values?.['xplan:art'] !== "" && (
                                                        <div  className={"text-xs pb-3 pl-2"}>
                                                            <b className={"text-gray-600/60 "}>Art: </b><br/> {data?.[key]?.values?.['xplan:art']?.toString()}
                                                        </div>
                                                    )}
                                                    {data?.[key]?.values?.['xplan:referenzURL'] && data?.[key]?.values?.['xplan:referenzURL'] !== "" && 
                                                        data?.[key]?.values?.['xplan:referenzURL']?.toString().includes("http") ? (
                                                            <div  className={"text-xs pb-3 pl-2 w-full"}>
                                                                <b className={"text-gray-600/60 "}>Datei: </b>
                                                                <div className='flex gap-1 justify-between items-center'>
                                                                    <a 
                                                                        href={data?.[key]?.values?.['xplan:referenzURL']?.toString()}
                                                                        target="_blank" 
                                                                        rel="noopener noreferrer" 
                                                                        className="text-blue-500 underline"
                                                                    >
                                                                        {data?.[key]?.values?.['xplan:referenzURL']?.toString()}
                                                                    </a>
                                                                </div>
                                                            </div>
                                                        ) : (
                                                            <div  className={"text-xs pb-3 pl-2 w-full"}>
                                                                <b className={"text-gray-600/60 "}>Datei: </b>
                                                                <div className='flex gap-1 justify-between items-center'>
                                                                    <div>{data?.[key]?.values?.['xplan:referenzURL']?.toString()}</div>
                                                                    {refs.includes(data?.[key]?.values?.['xplan:referenzURL']?.toString()) ? (
                                                                        <button 
                                                                            onClick={(e) => {
                                                                                e.stopPropagation();
                                                                                generateDownloadUrl(data?.[key]?.values?.['xplan:referenzURL']?.toString());
                                                                            }}  
                                                                            className="cursor-pointer flex gap-1 justify-center items-center"
                                                                        >
                                                                            <GoDownload className={"h-[15px] w-[15px] text-gray-900"}/>
                                                                            <div className='font-semibold'>Download</div>
                                                                        </button>
                                                                    ) : (
                                                                        <div>
                                                                            <span className='text-gray-500'>Datei nicht verfügbar</span>
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        )
                                                    }
                                                    {data?.[key]?.values?.['xplan:georefURL'] && data?.[key]?.values?.['xplan:georefURL'] !== "" && (
                                                        <div  className={"text-xs pb-3 pl-2 w-full"}>
                                                            <b className={"text-gray-600/60 "}>Geo Datei: </b>
                                                            <div className='flex gap-1 justify-between items-center'>
                                                                <div>{data?.[key]?.values?.['xplan:georefURL']?.toString()}</div>
                                                                {refs.includes(data?.[key]?.values?.['xplan:georefURL']?.toString()) ? (
                                                                    <button 
                                                                        onClick={(e) => {
                                                                            e.stopPropagation();
                                                                            generateDownloadUrl(data?.[key]?.values?.['xplan:georefURL']?.toString());
                                                                        }}  
                                                                        className="cursor-pointer flex gap-1 justify-center items-center"
                                                                    >
                                                                        <GoDownload className={"h-[15px] w-[15px] text-gray-900"}/>
                                                                        <div className='font-semibold'>Download</div>
                                                                    </button>
                                                                ) : (
                                                                    <div>
                                                                        <span className='text-gray-500'>Datei nicht verfügbar</span>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                            </li>
                                        );
                                    } else if(data?.[key]?.type === "json") {

                                        return (
                                            <li className={"mb-4"} key={index}>
                                                <span className={"text-xs font-bold mb-2 text-gray-900 block"} id={data?.[key]?.name} title={data?.[key]?.name}>{data?.[key]?.name}:</span>
                                                {data?.[key]?.values?.map((el) => (
                                                    <div  className={"border-gray-300 border-l-2"}>
                                                        <div  className={"text-xs pb-3 pl-2"}>
                                                            <b className={"text-gray-600/60"}>{el?.label}: </b><br/> {el?.value?.toString()}

                                                        </div>
                                                    </div>
                                                ))}
                                               
                                            </li>
                                        );
                                    } else {
                                        return (
                                            <li className={"mb-4"} key={index}>
                                                <div  className={" justify-between  text-sm  gap-2 "}>
                                                    <span className={"text-xs font-bold text-gray-900 block"} id={data?.[key]?.name} title={data?.[key]?.name}>{data?.[key]?.name}:</span>
                                                    <span className={"text-xs block  text-gray-600  text-left"}><pre className={"text-xs"}>{data?.[key]?.values?.toString()}</pre></span>
                                                </div>
                                            </li>
                                        );
                                    }
                                } else {
                                    return null;
                                }
                            })
                        }
                    </ul>
                </div>
            );
        }
    }


    // Convert the object to an array of entries
    let detailsArray = Object.entries(detailsData);

    // Sort the array by 'icon' and then by 'name'
    detailsArray.sort((a, b) => {
        let iconA = a[1].icon?.toLowerCase();
        let iconB = b[1].icon?.toLowerCase();
        let nameA = a[1].name?.toLowerCase();
        let nameB = b[1].name?.toLowerCase();

        if (iconA < iconB) return -1;
        if (iconA > iconB) return 1;
        if (nameA < nameB) return -1;
        if (nameA > nameB) return 1;
        return 0;
    });

    // Convert the array back to an object
    let entries = Object.fromEntries(detailsArray);


    return (
        <Transition.Root show={showDetails} as={Fragment}>
            <Dialog className="relative z-10" onClose={setShowDetails}>

                <div className="fixed inset-0 overflow-hidden">
                    <div className="absolute inset-0 overflow-hidden">
                        <div className="pointer-events-none fixed inset-y-0 z-50 right-0 flex max-w-full pl-10 sm:pl-16  mt-[59px] lg:mt-[0px]  sideOver ">
                            <Transition.Child
                                as={Fragment}
                                enter="transform transition ease-in-out duration-500 sm:duration-700"
                                enterFrom="translate-x-full"
                                enterTo="translate-x-0"
                                leave="transform transition ease-in-out duration-500 sm:duration-700"
                                leaveFrom="translate-x-0"
                                leaveTo="translate-x-full"
                            >
                                <Dialog.Panel className="pointer-events-auto w-screen max-w-md">
                                    <div className="flex h-full flex-col overflow-y-scroll bg-white px-2 py-14 shadow-xl">
                                        <div className="px-4">
                                            <div className="flex items-start justify-between">
                                                <Dialog.Title className="text-xl px-2 mb-6 font-semibold leading-6 text-gray-900">Ebenen</Dialog.Title>
                                                <div className="ml-3 flex h-7 items-center">
                                                    <button
                                                        type="button"
                                                        className="relative rounded-md bg-white text-gray-900 hover:text-gray-600 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2"
                                                        onClick={() => setShowDetails(false)}
                                                    >
                                                        <span className="absolute -inset-2.5" />
                                                        <span className="sr-only">Close panel</span>
                                                        <XMarkIcon className="h-9 w-9 " aria-hidden="true" />
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="relative mt-6 flex-1 px-4 sm:px-6">
                                            {
                                                Object.keys(entries)?.map(( el, index) => {
                                                    return(
                                                        <Accordion key={index}>
                                                            <AccordionSummary
                                                                expandIcon={<MdArrowForwardIos className={"text-lg truncate font-bold text-gray-900"} />}
                                                                aria-controls="panel2-content"
                                                                id="sideOverAccordingTitle"
                                                            >
                                                                <div className={"flex overflow-hidden justify-between truncate w-full mr-2"}>
                                                                    {(detailsData?.[el]?.name && detailsData?.[el]?.icon === "a") ? (<b className={"flex w-full truncate"}><TbPointFilled   className={"mr-2"} /><span style={{maxWidth: "300px"}} className={"truncate max-w-full block"}>{detailsData?.[el]?.name}</span></b>) : ("")}
                                                                    {(detailsData?.[el]?.name && detailsData?.[el]?.icon === "b") ? (<b className={"flex w-full truncate"}><MdLinearScale className={"mr-2"} /><span style={{maxWidth: "300px"}} className={"truncate max-w-full block"}>{detailsData?.[el]?.name}</span></b>) : ("")}
                                                                    {(detailsData?.[el]?.name && detailsData?.[el]?.icon === "c") ? (<b className={"flex w-full truncate"}><PiPolygon className={"mr-2"} /><span style={{maxWidth: "300px"}} className={"truncate max-w-full block"}>{detailsData?.[el]?.name}</span></b>) : ("")}
                                                                    <button
                                                                        onClick={(e) => {
                                                                            e.stopPropagation();
                                                                            handleZoomToLayer(entries[el].boundary,map);
                                                                            handleLayerBlink(entries[el].layerId, entries[el].id, map, layerBlink, setLayerBlink);
                                                                        }}
                                                                        className='text-gray-600 hover:text-gray-900 cursor-pointer'
                                                                        title='Auf Layer zoomen'
                                                                    >
                                                                        <RiFocus3Line title={"Hervorheben in der Karte"} className={"mr-2"}/>
                                                                    </button>
                                                                </div>
                                                            </AccordionSummary>
                                                            <AccordionDetails>
                                                                {parseDetails(detailsData?.[el]?.data?.details)}
                                                                {parseDetails(detailsData?.[el]?.data?.ref)}
                                                            </AccordionDetails>
                                                        </Accordion>
                                                    )
                                                })
                                            }
                                        </div>
                                    </div>
                                </Dialog.Panel>
                            </Transition.Child>
                        </div>
                    </div>
                </div>
            </Dialog>
        </Transition.Root>
    )
}
